import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { UrlApi } from "../../../services/apirest";

const CambiarSucursal = ({
  open,
  onClose,
  data,
  sucursales,
  getRegulador,
  showToast,
}) => {
  const { id_regulador: id, sucursal } = data;
  console.log(data);

  const [sucursalParaCambio, setSucursalParaCambio] = useState(sucursal || "");

  const handleSaveChanges = async () => {
    if (!sucursalParaCambio) return;

    const response = await fetch(
      `${UrlApi}/reguladores_abm/cambioDeSucursal/enCamino/${parseInt(id)}`,
      {
        headers: { "Content-Type": "application/json" },
        method: "PUT",
        body: JSON.stringify({ sucursal_destino: sucursalParaCambio }),
      }
    );
    if (!response.ok) {
      showToast("Ocurrio un error al cambiar la sucursal", "error");
      return;
    } else {
      showToast("El cambio se realizo correctamente", "success");
      getRegulador();
      onClose();
    }
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle
        sx={{ color: "#fff" }}
        id="customized-dialog-title"
        backgroundColor="#1F618D"
        p={1.5}
      >
        Cambiar la sucursal del regulador
      </DialogTitle>

      <DialogContent dividers>
        <FormControl fullWidth>
          <InputLabel id="sucursalParaCambio">Nueva sucursal</InputLabel>
          <Select
            labelId="sucursalParaCambio"
            id="sucursalParaCambio"
            value={sucursalParaCambio}
            label="Nueva sucursal"
            onChange={(e) => setSucursalParaCambio(e.target.value)}
          >
            <MenuItem value={""}>Seleccione una sucursal</MenuItem>
            {sucursales?.map((sucursal) => (
              <MenuItem key={sucursal.id} value={sucursal.id}>
                {sucursal.nombre}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ display: "felx", justifyContent: "end" }}>
        <Button
          autoFocus
          onClick={onClose}
          variant="contained"
          color="error"
          sx={{ width: "150px" }}
        >
          Volver
        </Button>
        <Button
          autoFocus
          onClick={handleSaveChanges}
          variant="contained"
          color="primary"
          disabled={!sucursalParaCambio}
          sx={{ width: "150px" }}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CambiarSucursal;
